import React, { useState } from "react";
import { getApi } from "../../api/endpoints";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants';
import Page from "../Page.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import ListingComponent from "../../components/ListingComponent.js";
import UiAction from "../../components/UiAction.js";
import { useNavigate } from "react-router-dom";
import UI_ACTIONS from "../../data/UiActionConstants.js";
import { useDispatch, useSelector } from "react-redux";
import { updateQueryParams, selectQueryParams, resetQueryParams } from "../../ui/customerListingReducer.js";
import FiltersFormPartial from "./FiltersFormPartial.js";
import HeadUserFilters from "../../models/HeadUserFilters.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPeopleArrows } from "@fortawesome/free-solid-svg-icons";

const Index = (props) => {
  const defaultHeaderConfig = { disableSort: true };
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryParams = useSelector(selectQueryParams);
  const [reset, setReset] = useState(false);
  const headUserFiltersObj = new HeadUserFilters();
  const [headUserFilters, setHeadUserFilters] = useState(headUserFiltersObj.toStateJson());

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
      disableSort: false
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name',
    },
    {
      ...defaultHeaderConfig,
      label: 'Mobile Number',
      attr: 'mobile_number',
    },
    {
      ...defaultHeaderConfig,
      label: 'Email',
      attr: 'email',
    },
    {
      ...defaultHeaderConfig,
      label: 'User Type',
      value: (row) => {
        return row.users_types.map((user_type) => {
          if(user_type.role_name == "area_head") return `${user_type.role_name} { ${row.profiles} }  \n`
          return `${user_type.role_name}  `
        })
      }
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_head_user.name)}>
            <span style={{ cursor: 'pointer' }} onClick={(e) => onEditClick(row.id)}>
              <FontAwesomeIcon icon={faEdit} />
            </span>
          </UiAction>

          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.map_head_user.name)}>
            <span style={{ cursor: 'pointer'  }} onClick={(e) => onMapUserClick(row.id)}>
              <div className="rounded px-1" style={{ background: '#E4F0E1', outline: 'solid 1px #7cc47b' }}>
                <span className="font-size-10 me-1">Map User</span>
                <span><FontAwesomeIcon icon={faPeopleArrows} /></span>
              </div>
            </span>
          </UiAction>
        </div>
      }
    }
  ]

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_head_user.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add New Head User</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  const onNewClick = () => {
    navigate('/manage_users/new');
  }

  const onEditClick = (id) => {
    navigate(`/manage_users/${id}/edit`);
  }

  const onMapUserClick = (id) => {
    navigate (`/manage_users/${id}/map`);
    dispatch(resetQueryParams());
  }

  const onSearch = (params) => {
    try{
      dispatch(updateQueryParams({
        queryParams: { ...queryParams, page: 1, per_page: 25,
          filters: JSON.parse(JSON.stringify(params.head_user))
        }
      }));
    } catch(error){

  }
  }

  const onSearchClick = () => {
    try{
      onSearch(new HeadUserFilters(headUserFilters).toApiJson());
    } catch(error){
      setHeadUserFilters(new HeadUserFilters(headUserFilters));
    }
  }

  const onResetClick = () => {
    try{
      dispatch(resetQueryParams());
      setHeadUserFilters(new HeadUserFilters());
      setReset(!reset);
    } catch(error){

    }
  }

  return <Page
  uiPage={uiManager.getUiPage(PAGES.HeadUsersListingPage.name)}
  breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Manage Head Users" }]}
  className={'manage-users-page'}
  >
	  <PageContentWrapper contentHeading={"Head Users List - Results"}>
      <form className="row g-2" autoComplete="off">
          <FiltersFormPartial headUserFilters={headUserFilters} setHeadUserFilters={setHeadUserFilters} reset={reset} />
          <div className="d-flex justify-content-end">
            <button type="button" className="btn mx-3 btn-voltup-theme" style={{ width: "120px" }} onClick={onSearchClick}>
              Search
            </button>
            <button type="button" className="btn mx-3 btn-voltup-theme" style={{ width: "120px" }} onClick={onResetClick}>
              Reset
            </button>
          </div>
      </form>
      <ListingComponent
        key={'PAGES.HeadUsersListingPage.name'}
        listingMutation={getApi('headUsers')}
        className="manage-head-users-listing-page"
        headers={headers}
        recordsKey="head_users"
        searchBy={['ID','Name', 'Mobile Number']}
        tableHeaderActionsComponent={tableHeaderActionsComponent()}
        filtersModel={ headUserFilters }
      />
	  </PageContentWrapper>
</Page>
};

export default Index;
